let product = {
    init: function () {
        product.contentReadMore();
        product.contentReadMoreToggle();
        product.imageZoom();
        product.contentSkip();

        $(window).resize(function () {
            product.contentReadMore();
            product.imageZoom();
        });
    },

    contentReadMore: function () {
        if ($(window).width() <= 768) {
            $('.product-intro').addClass('read-more');
        } else {
            $('.product-intro').removeClass('read-more');
        }
    },

    contentReadMoreToggle: function () {
        $(document).on('click', '.product-intro__content--read-more button', function (e) {
            e.preventDefault();

            $('.product-intro').toggleClass('read-more--open');
        });
    },

    contentSkip: function () {
        $(document).on('click', '.single-product .skip-navigation', function (e) {
            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: $('.product-intro').offset().top - 230,
                },
                1000
            );
        });
    },

    imageZoom: function () {
        if ($(window).width() > 768) {
            $('.image-zoom').imagezoomsl({
                innerzoom: true,
                magnifierborder: 'none',
                zoomrange: [2, 2],
                zoomstart: 2,
            });
        }
    },
};

$(document).ready(function () {
    product.init();
});
